// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { showSnackBar } from "../../snackbar/actions"
import { NarratePreferences } from "../../../generated/wisetime/user/assistant/v4/preferences_pb"
import { executor, narratePreferencesService } from "../../../app/rpc"
import { create } from "@bufbuild/protobuf"
import { EmptySchema } from "@bufbuild/protobuf/wkt"

type GetDefaultNarratePreferencesRpc = () => Observable<NarratePreferences>

export const getDefaultNarratePreferences = (getDefaultNarratePreferencesRpc: GetDefaultNarratePreferencesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.getDefaultNarratePreferences.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(getDefaultNarratePreferencesRpc),
        map(t => t),
        map(Slice.setDefaultNarratePreferences),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_get_narrate_preferences_failed",
            message: "Failed to load narrate preferences. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const getDefaultNarratePreferencesRpc = (): Observable<NarratePreferences> =>
  executor(() => narratePreferencesService.getDefaultNarratePreferences(create(EmptySchema, {})))

export default getDefaultNarratePreferences(getDefaultNarratePreferencesRpc)
